type ErpLoadingProps = {
  mode?: "session" | "route";
  title?: string;
  description?: string;
  label?: string;
};

export function ErpLoadingMark() {
  return (
    <span className="erp-loading-mark" aria-hidden="true">
      <i />
      <i />
      <i />
      <i />
    </span>
  );
}

export function ErpLoading({
  mode = "route",
  title,
  description,
  label = "正在加载",
}: ErpLoadingProps) {
  return (
    <div
      className={`erp-loading erp-loading--${mode}`}
      role="status"
      aria-label={label}
    >
      <ErpLoadingMark />
      {title && <strong>{title}</strong>}
      {description && <span>{description}</span>}
    </div>
  );
}
